import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import language from '../../../../assets/languages/language';
import FD from '../../../RestAPI/fetchData';

import Loader from '../../../../common/loader';
import { canvasjsConfig } from '../../../../common/constant';
import { showFailure } from '../../../../common/toast';
/* eslint-disable */

class FRMCBTResult extends Component {
  //
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      idname: '',
      dataPointsOverAllGraph: [],
      dataPoints: [],
      totalQuestions: 0,
      isLoading: true,
      labelAngle: 0,
      labelFontSize: 15,
      activeTabFlashcards: 1,
      Message: false,
      isError: false,
      error: '',
      errorGraph: '',
      totalQuestionsChapterwise: 0,
      dataOfCurrentUser: '',
      dataOfEightyPercentileUser: '',
      dataOfTwentyPercentileUser: '',
      exam_name: '',
      average: '',
    };
  }

  componentDidMount() {
    const w = window.innerWidth;
    // const h = window.innerHeight;
    if (w > 1200) {
      this.setState({
        labelAngle: 0,
        labelFontSize: 15,
      });
    } else if (w > 991 && w < 1200) {
      this.setState({
        labelAngle: -20,
        labelFontSize: 12,
      });
    } else if (w > 767 && w < 991) {
      this.setState({
        labelAngle: 50,
        labelFontSize: 15,
      });
    } else {
      this.setState({
        labelAngle: -90,
        labelFontSize: 12,
      });
    }

    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      test_id: this.props.params.test_id
        ? parseInt(this.props.params.test_id)
        : null,
      level: this.props.params.level ? parseInt(this.props.params.level) : null,
      totalQuestion: this.props.params.totalQuestions
        ? parseInt(this.props.params.totalQuestions)
        : null,
      timer: this.props.params.timer ? parseInt(this.props.params.timer) : 0,
    };

    this.getGraphData(data);
    this.getGraphoverAllGraphData(data);
  }
  // get data for overall graph
  // myResize = () => {

  //   }
  flashcardTabToggle = (tab) => {
    if (this.state.activeTabFlashcards !== tab) {
      this.setState({
        activeTabFlashcards: tab,
      });
    }
  };
  getGraphoverAllGraphData = (data) => {
    FD.callAPI(
      App_data.backend_api + '/frmCBTMockExams/getCBTMockUserGraph',
      data
    ).then(async (res) => {
      if (res.graphData) {
        this.setState({
          isLoading: false,
          totalQuestions: this.props.params.totalQuestions,
          average: res.graphData.averageScore,
        });
        this.formatoverAllGraphData(res);
      } else {
        this.setState({
          isLoading: false,
        });
        showFailure(res.message);
      }
    });
  };
  // get data for chaptervise graph
  getGraphData = (data) => {
    FD.callAPI(
      App_data.backend_api + '/frmCBTMockExams/getCBTMockUserGraphBookWise',
      data
    ).then(async (res) => {
      this.setState({
        isLoading: false,
        totalQuestionsChapterwise: this.props.params.totalQuestions,
        exam_name: res.graphData,
      });
      this.formatData(res);
    });
  };
  //format data as requirement for overall graph
  formatoverAllGraphData = (res) => {
    let { graphData } = res;

    if (!res.Error) {
      this.setState({
        dataOfCurrentUser: graphData
          ? graphData.dataOfCurrentUser.score
          : this.state.dataOfCurrentUser,
        dataOfEightyPercentileUser: graphData
          ? graphData.dataOfEightyPercentileUser.score
          : this.state.dataOfEightyPercentileUser,
        dataOfTwentyPercentileUser: graphData
          ? graphData.dataOfTwentyPercentileUser.score
          : this.state.dataOfTwentyPercentileUser,
      });
      const { totalQuestions } = this.state;
      let temp = [graphData];
      graphData = temp;

      // Reference line for 70%
      let referenceLine = {
        type: 'line',
        color: '#fff',
        dataPoints: [
          {
            x: -15,

            y: 100,
          },
          {
            x: 20,

            y: 100,
          },
          {
            x: 20,

            y: 100,
          },
        ],
        markerType: 'none',
      };
      // 20% line
      let dataOfTwentyOverAllGraph = {
        showInLegend: false,
        name: '20%',

        type: 'line',
        lineDashType: 'dash',
        color: '#39c089',
        dataPoints: [],
        markerType: 'none',
      };
      //80% line
      let dataOfEightyOverAllGraph = {
        showInLegend: false,

        name: '80%',
        type: 'line',
        lineDashType: 'dot',
        color: '#1d364b',
        dataPoints: [],
        markerType: 'none',
      };
      //User score line
      let UserScoreOverAllGraph = {
        showInLegend: false,
        name: `${language.LC().GRAPHSCORE}`,

        type: 'line',
        color: '#1f8ceb',
        markerType: 'none',
        dataPoints: [],
        overlayBars: true,
      };
      //User score box

      let scorePercentage =
        graphData[0].dataOfCurrentUser.score == null
          ? 0
          : Math.ceil(
              (graphData[0].dataOfCurrentUser.score / totalQuestions) * 100
            );

      let UserScoreBoxOverAllGraph2 = {
        type: 'rangeColumn',

        color: 'hsl(200deg 67% 88%)',
        dataPoints: [],
      };

      UserScoreBoxOverAllGraph2.dataPoints.push({
        x: 1.39,

        y: [scorePercentage - 5, scorePercentage + 5],
      });

      let dataOfCurrentUserLineStart = {
        x: -0.2,

        y: scorePercentage,
      };
      let dataOfCurrentUserLineMid = {
        x: 2.8,

        y: scorePercentage,
      };
      let dataOfCurrentUserLineEnd = {
        x: 2.8,
        y: null,
      };

      UserScoreOverAllGraph.dataPoints.push(
        dataOfCurrentUserLineStart,
        dataOfCurrentUserLineMid,
        dataOfCurrentUserLineEnd
      );

      let dataOfTwentyPercentileUserlineStart = {
        x: -3,

        y:
          graphData[0].dataOfTwentyPercentileUser.score == null
            ? 0
            : Math.ceil(
                (graphData[0].dataOfTwentyPercentileUser.score /
                  totalQuestions) *
                  100
              ),
      };
      let dataOfTwentyPercentileUserlineMid = {
        x: 7,

        y:
          graphData[0].dataOfTwentyPercentileUser.score == null
            ? 0
            : Math.ceil(
                (graphData[0].dataOfTwentyPercentileUser.score /
                  totalQuestions) *
                  100
              ),
      };
      let dataOfTwentyPercentileUserlineEnd = {
        x: 7,
        y: null,
      };
      dataOfTwentyOverAllGraph.dataPoints.push(
        dataOfTwentyPercentileUserlineStart,
        dataOfTwentyPercentileUserlineMid,
        dataOfTwentyPercentileUserlineEnd
      );
      let dataOfEightyPercentileUserLineStart = {
        x: -3,

        y:
          graphData[0].dataOfEightyPercentileUser.score == null
            ? 0
            : Math.ceil(
                (graphData[0].dataOfEightyPercentileUser.score /
                  totalQuestions) *
                  100
              ),
      };
      let dataOfEightyPercentileUserLineMid = {
        x: 7,

        y:
          graphData[0].dataOfEightyPercentileUser.score == null
            ? 0
            : Math.ceil(
                (graphData[0].dataOfEightyPercentileUser.score /
                  totalQuestions) *
                  100
              ),
      };

      let dataOfEightyPercentileUserLineEnd = {
        x: 7,
        y: null,
      };
      dataOfEightyOverAllGraph.dataPoints.push(
        dataOfEightyPercentileUserLineStart,
        dataOfEightyPercentileUserLineMid,
        dataOfEightyPercentileUserLineEnd
      );
      const overAllGraphData = [];
      overAllGraphData.push(
        UserScoreBoxOverAllGraph2,
        dataOfTwentyOverAllGraph,
        dataOfEightyOverAllGraph,
        UserScoreOverAllGraph,
        referenceLine
      );

      this.setState(
        {
          dataPointsOverAllGraph: overAllGraphData,
        },
        () => {
          this.showGraphOverAll(); //Show overall graph
        }
      );
    } else {
      this.setState({ isError: true, error: res.Error });
    }
  };
  //Show overall graph
  showGraphOverAll = () => {
    const { dataPointsOverAllGraph } = this.state;

    var chart = new window.CanvasJS.Chart('chartContainerOverAllGraph', {
      animationEnabled: true,
      axisY: canvasjsConfig.axisY,
      axisX: canvasjsConfig.axisX,
      dataPointWidth: 90,
      dataPointMaxWidth: 80,
      dataPointMinWidth: 80,
      toolTip: canvasjsConfig.toolTip,

      legend: {
        fontSize: 18,
      },
      data: dataPointsOverAllGraph,
      interactivityEnabled: false,
    });
    chart.render();
  };
  //Format data as requirement
  formatData = (res) => {
    const { graphData } = res;

    if (!res.Message) {
      let initialValue = 0;
      // Reference line for 70%
      let referenceLine = {
        type: 'line',
        color: '#fff',
        dataPoints: [
          {
            x: 0,

            y: 110,
          },
          {
            x: 20,

            y: 110,
          },
          {
            x: 20,

            y: 110,
          },
        ],
        markerType: 'none',
      };
      //20% line chaptervise graph
      let dataOfTwenty = {
        showInLegend: false,

        name: '20%',
        type: 'line',
        lineDashType: 'dash',
        color: '#39c089',
        dataPoints: [],
        markerType: 'none',
      };
      //80% line chaptervise graph
      let dataOfEighty = {
        showInLegend: false,
        name: '80%',
        type: 'line',
        lineDashType: 'dot',
        color: '#1d364b',
        dataPoints: [],
        markerType: 'none',
      };
      //Userscore line chaptervise graph
      let UserScore = {
        showInLegend: false,
        name: `${language.LC().GRAPHSCORE}`,
        type: 'line',
        color: 'hsl(219deg 62% 44%)',
        markerType: 'none',
        dataPoints: [],
        overlayBars: true,
      };
      //User Score Box chaptervise graph
      // let UserScoreBox = {
      //   type: 'rangeColumn',
      //   color: '#cce7f5',
      //   dataPoints: [],
      // };
      // initialValue = -10;
      // for (let k = 0; k < graphData.length; k++) {
      //   UserScoreBox.dataPoints.push({
      //     x: initialValue + 15,

      //     y: [
      //       graphData[k].dataOfCurrentUser.Percentage - 10,
      //       graphData[k].dataOfCurrentUser.Percentage + 10,
      //     ],
      //   });
      //   initialValue += 15;
      // }
      let UserScoreBox2 = {
        showInLegend: false,
        // legendMarkerType: 'square',
        name: `${language.LC().GRAPHSCOREBOX}`,
        type: 'rangeColumn',
        color: '#cce7f5',
        dataPoints: [],
      };
      initialValue = -10;
      for (let k = 0; k < graphData.length; k++) {
        UserScoreBox2.dataPoints.push({
          x: initialValue + 15,
          label: `${graphData[k].chapterDetails['chapters_frm.chapter_name']}`,
          y: [
            graphData[k].dataOfCurrentUser.Percentage - 10,
            graphData[k].dataOfCurrentUser.Percentage + 10,
          ],
        });
        let dataOfCurrentUserLineStart = {
          x: initialValue + 15 - 1.5,

          y: graphData[k].dataOfCurrentUser.Percentage,
        };
        let dataOfCurrentUserLineMid = {
          x: initialValue + 15 + 1.5,

          y: graphData[k].dataOfCurrentUser.Percentage,
        };
        let dataOfCurrentUserLineEnd = {
          x: initialValue + 15 + 1.5,
          y: null,
        };
        UserScore.dataPoints.push(
          dataOfCurrentUserLineStart,
          dataOfCurrentUserLineMid,
          dataOfCurrentUserLineEnd
        );
        initialValue += 15;
      }
      initialValue = 0;
      for (let i = 0; i < graphData.length; i++) {
        let dataOfTwentyPercentileUserlineStart = {
          x: initialValue,

          y: graphData[i].dataOfTwentyPercentileUser.Percentage,
        };
        let dataOfTwentyPercentileUserlineMid = {
          x: initialValue + 10,

          y: graphData[i].dataOfTwentyPercentileUser.Percentage,
        };
        let dataOfTwentyPercentileUserlineEnd = {
          x: initialValue + 10,

          y: null,
        };
        dataOfTwenty.dataPoints.push(
          dataOfTwentyPercentileUserlineStart,
          dataOfTwentyPercentileUserlineMid,
          dataOfTwentyPercentileUserlineEnd
        );
        let dataOfEightyPercentileUserLineStart = {
          x: initialValue,

          y: graphData[i].dataOfEightyPercentileUser.Percentage,
        };
        let dataOfEightyPercentileUserLineMid = {
          x: initialValue + 10,

          y: graphData[i].dataOfEightyPercentileUser.Percentage,
        };
        let dataOfEightyPercentileUserLineEnd = {
          x: initialValue + 10,
          y: null,
        };
        dataOfEighty.dataPoints.push(
          dataOfEightyPercentileUserLineStart,
          dataOfEightyPercentileUserLineMid,
          dataOfEightyPercentileUserLineEnd
        );

        initialValue += 15;
      }
      const data = [];
      data.push(
        UserScoreBox2,
        dataOfTwenty,
        dataOfEighty,
        UserScore,
        referenceLine
      );

      this.setState(
        {
          dataPoints: data,
        },
        () => {
          this.showGraph(); //Show chaptervise graph
        }
      );
    } else {
      this.setState({ Message: true, errorGraph: res.Message });
    }
  };

  // show graph chaptervise graph
  showGraph = () => {
    const { dataPoints } = this.state;

    var chart = new window.CanvasJS.Chart('chartContainer', {
      animationEnabled: true,

      axisY: canvasjsConfig.axisY,
      axisX: {
        ...canvasjsConfig.axisX,
        labelAngle: this.state.labelAngle,
        labelFontSize: this.state.labelFontSize,
      },
      dataPointWidth: 60,
      dataPointMaxWidth: 60,
      dataPointMinWidth: 60,
      toolTip: canvasjsConfig.toolTip,
      data: dataPoints,

      legend: {
        fontSize: 18,
      },
      interactivityEnabled: false,
    });
    chart.render();
  };

  render() {
    const {
      dataOfCurrentUser,
      dataOfEightyPercentileUser,
      dataOfTwentyPercentileUser,
      totalQuestions,
      isError,
      Message,
      exam_name,
      errorGraph,
      activeTabFlashcards,
      average,
    } = this.state;

    const { isLoading } = this.state;
    return !isLoading ? (
      <div>
        {isError ? (
          <div className='chart-graph-wrapper'>
            <div className='question-not-found'>
              <img
                width='62px'
                src={App_data.frontend_url + '/img/questions/icon_nomock.png'}
                alt='img'
              />
              <div>{`${errorGraph}`}</div>
            </div>
          </div>
        ) : (
          <div className='chart-graph-wrapper'>
            {' '}
            <h1 className='overAllScore'>{`${language.LC().OVERALLRESULT}`}</h1>
            <div className='row align-items-center'>
              <div className='col-lg-6'>
                {' '}
                <div
                  id='chartContainerOverAllGraph'
                  className='js-chart-wrap'
                />
                <ul className='legend-wrapper'>
                  <li>
                    <span className='square-box' /> {language.LC().SCOREBOX}
                  </li>
                  <li>
                    <span className='line-dash' /> {language.LC().Percentile_20}
                  </li>
                  <li>
                    <span className='line-dots' /> {language.LC().Percentile_80}
                  </li>
                  <li>
                    <span className='line-normal' /> {language.LC().YOURSCORE}
                  </li>
                </ul>
              </div>
              <div className='col-lg-6'>
                <div className=' graphData'>
                  <div className='graphScoreData'>
                    <div className='graphScore'>{`${
                      dataOfTwentyPercentileUser
                        ? Math.ceil(
                            (dataOfTwentyPercentileUser / totalQuestions) * 100
                          )
                        : 0
                    }%`}</div>
                    <div className='graphLabel'>
                      <span className='percentileTwentyScore-box' />{' '}
                      {language.LC().Percentile_20}
                    </div>
                  </div>
                  <div className='graphScoreData'>
                    <div className='graphScore'>{`${
                      dataOfEightyPercentileUser
                        ? Math.ceil(
                            (dataOfEightyPercentileUser / totalQuestions) * 100
                          )
                        : 0
                    }%`}</div>
                    <div className='graphLabel'>
                      <span className='percentileEightyScore-box' />{' '}
                      {language.LC().Percentile_80}
                    </div>
                  </div>
                  <div className='graphScoreData'>
                    <div className='graphScore'>{`${
                      dataOfCurrentUser
                        ? Math.ceil((dataOfCurrentUser / totalQuestions) * 100)
                        : 0
                    }%`}</div>
                    <div className='graphLabel'>
                      <span className='score-box' />{' '}
                      {`${language.LC().YOURSCORE}`}
                    </div>
                  </div>
                  <div className='graphScoreData'>
                    <div className='graphScore'>{`${
                      dataOfTwentyPercentileUser
                        ? Math.ceil((average / totalQuestions) * 100)
                        : 0
                    }%`}</div>
                    <div className='graphLabel'>
                      <span className='average-box' />{' '}
                      {language.LC().AVERAGE_SCORE}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {Message ? null : (
          <div className=' chart-graph-wrapper'>
            {' '}
            <h1 className='overAllScore'>{`${
              language.LC().FRMBookWiseScore
            }`}</h1>
            <div id='chartContainer' className='js-chart-wrap' />
            <ul className='legend-wrapper'>
              <li>
                <span className='square-box' /> {language.LC().SCOREBOX}
              </li>
              <li>
                <span className='line-dash' /> {language.LC().Percentile_20}
              </li>
              <li>
                <span className='line-dots' /> {language.LC().Percentile_80}
              </li>
              <li>
                <span className='line-normal' />
                {language.LC().YOURSCORE}
              </li>
            </ul>
            <h1 className='mt-5'>Mean Score by Topic Area</h1>
            <div className='d-flex header-card-dashboard tab-header-wrap mt-2'>
              <ul className='dashboard-card-header-tab'>
                {exam_name
                  ? exam_name.map((exam, index) => {
                      return (
                        <li
                          onClick={() => {
                            this.flashcardTabToggle(index + 1);
                          }}
                          className={
                            activeTabFlashcards === index + 1 ? 'active' : ''
                          }
                        >
                          <span>
                            {exam.chapterDetails['chapters_frm.chapter_name']
                              .length > 20
                              ? `${exam.chapterDetails[
                                  'chapters_frm.chapter_name'
                                ].substring(0, 20)}...`
                              : exam.chapterDetails[
                                  'chapters_frm.chapter_name'
                                ]}
                          </span>
                        </li>
                      );
                    })
                  : null}
              </ul>
            </div>
            {exam_name
              ? exam_name.map((exam, index) => {
                  let x;

                  x =
                    this.state.activeTabFlashcards === index + 1 ? (
                      <div className='card tab-body-wrap'>
                        <div className='card-block dashboard-cards-scroll my-1'>
                          <div className='chart-wrapper'>
                            <div className=' graphData'>
                              <div className='graphScoreData'>
                                <div className='graphScore'>{`${
                                  exam.dataOfTwentyPercentileUser
                                    ? Math.ceil(
                                        exam.dataOfTwentyPercentileUser
                                          .Percentage
                                      )
                                    : 0
                                }%`}</div>
                                <div className='graphLabel'>
                                  <span className='percentileTwentyScore-box' />{' '}
                                  {language.LC().Percentile_20}
                                </div>
                              </div>
                              <div className='graphScoreData'>
                                <div className='graphScore'>{`${
                                  exam.dataOfEightyPercentileUser
                                    ? Math.ceil(
                                        exam.dataOfEightyPercentileUser
                                          .Percentage
                                      )
                                    : 0
                                }%`}</div>
                                <div className='graphLabel'>
                                  <span className='percentileEightyScore-box' />{' '}
                                  {language.LC().Percentile_80}
                                </div>
                              </div>
                              <div className='graphScoreData'>
                                <div className='graphScore'>{`${
                                  exam.dataOfCurrentUser
                                    ? Math.ceil(
                                        exam.dataOfCurrentUser.Percentage
                                      )
                                    : 0
                                }%`}</div>
                                <div className='graphLabel'>
                                  <span className='score-box' />{' '}
                                  {`${language.LC().YOURSCORE}`}
                                </div>
                              </div>
                              <div className='graphScoreData'>
                                <div className='graphScore'>{`${
                                  exam &&
                                  exam.chapterDetails &&
                                  exam.chapterDetails.totalQuestions
                                    ? Math.ceil(
                                        (exam.averageScore /
                                          exam.chapterDetails.totalQuestions) *
                                          100
                                      )
                                    : 0
                                }%`}</div>
                                <div className='graphLabel'>
                                  <span className='average-box' />{' '}
                                  {language.LC().AVERAGE_SCORE}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null;

                  return x;
                })
              : null}
            <div className='pt-2 text-center'>
              <p>{language.LC().DataDetail}</p>
            </div>
          </div>
        )}
      </div>
    ) : (
      <div id='chartContainer'>
        <Loader />
      </div>
    );
  }
}
export default FRMCBTResult;



// WEBPACK FOOTER //
// ./src/views/CBT/FRMCBT/ResultGraph/index.js